import ModalLayout from "components/modal/modal-layout/ModalLayout";
import { Button } from "react-bootstrap";
import { AI_ONLY_BENEFITS } from "../../constants";
import { ReactComponent as OutlineCheckSmall } from "assets/svg/outline-check-small.svg";
import styles from "./PlanModal.module.scss";
import Checkbox from "components/checkbox/Checkbox";
import { Link } from "react-router-dom";
import { AmplitudePageName, track } from "utils/amplitude";
import _ from "lodash";
import getClasses from "utils/getClasses";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";

type Props = {
  trialUrlPath: string;
  purchasePath: string;
  changePlanSearch: string;
  purchaseWithAddonPath: string;
  amplitudePageName: AmplitudePageName;
  amplitudeComponentName: string;
  onHide: () => void;
  isCurrentPlan: boolean;
  subPeriod: string | undefined;
  withSelect?: boolean;
  changePlanWithAddonSearch: string | undefined;
  currentSubClass: string | undefined;
  currentSubPeriod: string;
  subSuid: string;
  planPriceComponent: React.ReactNode;
  planDescription: React.ReactNode;
  aiToolkitCheckboxChecked: boolean;
  setAiToolkitCheckboxChecked: React.Dispatch<React.SetStateAction<boolean>>;
};

const PlanModal = ({
  onHide,
  trialUrlPath,
  purchasePath,
  purchaseWithAddonPath,
  amplitudePageName,
  amplitudeComponentName,
  isCurrentPlan,
  subPeriod,
  withSelect,
  currentSubClass,
  changePlanSearch,
  changePlanWithAddonSearch,
  subSuid,
  currentSubPeriod,
  planPriceComponent,
  planDescription,
  aiToolkitCheckboxChecked,
  setAiToolkitCheckboxChecked,
}: Props) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  let checkoutPath;
  if (aiToolkitCheckboxChecked) {
    if (withSelect) {
      checkoutPath = `/pro-dashboard/subscription-settings/${subSuid}/change${
        changePlanWithAddonSearch || ""
      }`;
    } else {
      checkoutPath = purchaseWithAddonPath;
    }
  } else {
    if (withSelect) {
      checkoutPath = `/pro-dashboard/subscription-settings/${subSuid}/change${
        changePlanSearch || ""
      }`;
    } else if (subPeriod === "month") {
      checkoutPath = trialUrlPath;
    } else {
      checkoutPath = purchasePath;
    }
  }

  return (
    <ModalLayout
      show={true}
      onHide={onHide}
      showHeaderDivider
      Header={"Core"}
      footerClass={styles["plan-modal__footer"]}
      headerClass={styles["plan-modal__header"]}
      Footer={
        <div className={styles["plan-modal__buttons-wrapper"]}>
          {(subPeriod === currentSubPeriod &&
            aiToolkitCheckboxChecked &&
            currentSubClass === "core-with-ai") ||
          (subPeriod === currentSubPeriod &&
            !aiToolkitCheckboxChecked &&
            currentSubClass === "core") ? (
            <Button
              variant="primary"
              className={getClasses("w-100 bd-16 smoothed")}
              size="lg"
              disabled
            >
              {withSelect
                ? "Select this plan"
                : !aiToolkitCheckboxChecked && subPeriod === "month"
                ? "Try for Free"
                : "Subscribe Now"}
            </Button>
          ) : (
            <>
              <Link
                to={checkoutPath}
                className={`${
                  isPhonePortrait ? styles["plan-modal__cta"] : ""
                }`}
              >
                <Button
                  variant="primary"
                  size="lg"
                  className={getClasses("w-100 bd-16 smoothed")}
                  onClick={() => {
                    track(
                      amplitudePageName,
                      [amplitudeComponentName, "start-trial-button"],
                      "click",
                      {
                        eventProperties: {
                          "time-period": subPeriod,
                        },
                      },
                    );
                  }}
                >
                  {withSelect
                    ? "Select this plan"
                    : !aiToolkitCheckboxChecked && subPeriod === "month"
                    ? "Try for Free"
                    : "Subscribe Now"}
                </Button>
              </Link>
            </>
          )}
        </div>
      }
    >
      <div className={styles["plan-modal__addons-wrapper"]}>
        <div className={styles["plan-modal__price-description-wrapper"]}>
          {planPriceComponent}
          <div className={styles["plan-modal__description-wrapper"]}>
            {planDescription}
          </div>
        </div>
        <div className={styles["plan-modal__addon-title"]}>Add-On</div>
        <div
          className={styles["plan-modal__addon-modal-wrapper"]}
          onClick={() => {
            setAiToolkitCheckboxChecked(!aiToolkitCheckboxChecked);
          }}
        >
          <Checkbox
            variant="rectangle"
            checked={aiToolkitCheckboxChecked}
            readOnly
            onChange={_.noop}
          />
          <div className={styles["plan-modal__text-content"]}>
            <div className={styles["plan-modal__addon-lhs"]}>
              <div className={styles["plan-modal__addon-title-desc"]}>
                <div className={styles["plan-modal__addon-header"]}>
                  AI Toolkit
                </div>
                <div className={styles["plan-modal__addon-description"]}>
                  Save time & augment client care with AI-enhanced documentation
                  tools.
                </div>
                <div className={styles["plan-modal__addon-price"]}>
                  $9.98/mo
                </div>
              </div>
            </div>
            <div>
              {AI_ONLY_BENEFITS.map((benefit, index) => {
                return (
                  <div key={index} className={styles["plan-modal__benefit"]}>
                    <OutlineCheckSmall />
                    {benefit}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};

export default PlanModal;
